export const ASSIGNED_USER_UNIT = 'ASSIGNED_USER_UNIT';
export const ASSIGNED_UNITS_CELL_WIDTH = 140;
